import iconCheckCircle from "./iconCheckCircle";
import iconCaret from "./iconCaret";
import iconAddDRP from "./iconAddDRP";
import danger from "./danger";
import close from "./close";
import trash from "./trash";
import download from "./download";
import downloadIcon from "./downloadIcon";
import uploadIcon from "./upload";
import uploadIconDisabled from "./uploadDisabled";
import warning from "./warning";

import {
  one,
  twoInactive,
  threeInactive,
  fourInactive,
  fiveInactive,
  sixInactive,
  sevenInactive,
  timelineCheckmark,
} from "./timelineNumbers";

export const svgType = {
  iconCheckCircle: "iconCheckCircle",
  iconCaret: "iconCaret",
  iconAddDRP: "iconAddDRP",
  danger: "danger",
  close: "close",
  one: "one",
  twoInactive: "twoInactive",
  threeInactive: "threeInactive",
  fourInactive: "fourInactive",
  fiveInactive: "fiveInactive",
  sixInactive: "sixInactive",
  sevenInactive: "sevenInactive",
  trash: "trash",
  download: "download",
  timelineCheckmark: "timelineCheckmark",
  downloadIcon: "downloadIcon",
  uploadIcon: "uploadIcon",
  uploadIconDisabled: "uploadIconDisabled",
  warning: "warning",
};

const svgs = {
  iconCheckCircle,
  iconCaret,
  iconAddDRP,
  danger,
  close,
  one,
  twoInactive,
  threeInactive,
  fourInactive,
  fiveInactive,
  sixInactive,
  sevenInactive,
  trash,
  timelineCheckmark,
  download,
  downloadIcon,
  uploadIcon,
  uploadIconDisabled,
  warning,
};

export default svgs;
